import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { chartConfig } from '../../app.constants';
import {PdfExportService} from '../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'achoo-stacked-column-chart',
  templateUrl: './achoo-stacked-column-chart.component.html',
  styleUrls: ['./achoo-stacked-column-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AchooStackedColumnChartComponent implements OnInit {

  @Input() chartData: Array<object>;
  @Input() chartTitle: string | null;
  @Input() width: number;
  @Input() height: number;
  @Input() titleTooltip: string;
  options: object;
  constructor(private pdfService: PdfExportService) { }

  ngOnInit() {
    this.options = {
      chart: {
        type: chartConfig.type.column,
        zoomType: 'x',
        width: this.width,
        height: this.height,
        style: {
          fontFamily: chartConfig.font.light,
          overflow: 'visible'
        }
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        column: {
          maxPointWidth: 15,
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            style: {
              textShadow: false,
              textOutline: false,
            },
            formatter: function () {
              return ''; // always visible
            },
            verticalAlign: 'top',
            y: -20
          },
          marker: {
            enabled: false
          }
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            allowOverlap: true,
            enabled: true,
            crop: false,
            overflow: 'none',
          },
          pointWidth: 15,
          states: {
            hover: {
              enabled: false
            }
          },
          animation: !this.pdfService.exportingPdf
        }
      },
      credits: {
        enabled: false
      },
      series: this.chartData,
      title: {
        text : this.chartTitle,
        align: chartConfig.title.align,
        x: chartConfig.title.padding,
        y: chartConfig.title.padding
      },
      legend: {
        enabled: true,
        itemDistance: 7,
        verticalAlign: 'top',
        align: 'right',
        x: 12,
        y: -28,
        useHTML: true,
        symbolWidth: -1,
        symbolHeight: -1,
        labelFormatter: function () {
          return '<div class="highcharts-legend-item-content badge">' +
                    '<div class="highcharts-legend-item-symbol" style="background-color: ' + this.color + ';"> </div>' +
                    '<span class="highcharts-legend-item-text">' + this.name +  '<span>' +
                  '</div>';
        },
      },
      xAxis: {
        type: chartConfig.xAxis.type,
        tickLength: 0,
        labels: {
          style: {
            textTransform: 'uppercase',
            color: chartConfig.xAxis.labelColor
          }
        }
      },
      yAxis: {
        minorGridLineWidth: 0,
        lineColor: chartConfig.yAxis.lineColor,
        title: {
          enabled: false,
        },
        labels: {
          style: {
            color: chartConfig.yAxis.labelColor
          }
        },
        stackLabels: {
          enabled: !this.pdfService.exportingPdf,
          style: {
            fontWeight: 'bold',
            color: chartConfig.yAxis.lineColor || 'gray'
          }
        }
      },
      responsive: {
        rules: [{
          condition: {
            maxWidth: 300
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'top',
              layout: 'horizontal'
            },
            chart: {
              height: this.height,
            }
          }
        }]
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-stacked-column-chart/achoo-stacked-column-chart.component.ts